import api from "../../api";
import Leaflet from "../Leaflet";
import worldMap from '../../core/map';
import { filterFeature } from '../Leaflet/VectorLayer/VectorLayerUtils';

const get = (name, currentMap = worldMap.getCurrent()) => {
    return require('./../index').default.get(name, currentMap);
};

class ProtectAreaAfterSalesLayer {
    constructor(currentMap, theme) {
        this.hide = [];
        this.layer = new Leaflet.D3Layer();
        this.debounced = undefined;

        this.layer.setOptions({
            map: currentMap,
            cache: false,
            showAll: true,
            expandView: 0.5,
            autofocus: false,
            uniqueField: 'Id',
            scaleRange: [4, 18],
            above: true,
            value: 'Id',
            symbology: {
                type: 'choropleth',
                scale: 'jenks',
                theme: theme,
                style: {
                    highlight: true,
                    lineJoin: 'round',
                    color: '#023e8a',
                    fillColor: '#023e8a',
                    fillOpacity: 0.2,
                    opacity: 1,
                    weight: 2.8
                }
            }
        });

        this.layer.onLoad = (layerName, storeType, isDealership) => {
            this.loadProtectArea(layerName, storeType, isDealership)();

            if (!this.debounced) {
                this.debounced = this._debouncedLoadProtectArea(layerName, storeType, isDealership);
            }

            worldMap.on('moveend', this.debounced);
        };

        this.layer.offLoad = () => {
            this.layer.removeProtectArea();
        };

        this.layer.removeProtectArea = () => {
            if (this.debounced) {
                worldMap.off('moveend', this.debounced);
                this.debounced = undefined;
            }
            this.removeProtectArea();
        };

        this.layer.setHide = (id) => {
            return this.hide.push(id);
        };

        this.layer.removeHide = (id) => {
            return this.hide.splice(this.hide.indexOf(id), 1);
        };

        this.layer.getHide = () => {
            return this.hide;
        };

        this.layer.reloadProtectedArea = () => {
            worldMap.fire('moveend');
        };

        return this.layer;
    }

    removeProtectArea() {
        setTimeout(() => {
            this.layer.setFeatures(null, true);
        }, 300);
    }

    loadProtectArea(layerName, storeType, isDealership = false) {
        return () => {
            const bbox = worldMap.getCurrentBbox();
            const layer = get(layerName);

            api.afterSales.get.protectArea(isDealership, storeType, null, bbox).then((response) => {
                this.layer.setFeatures(null, true);
                const features = this.layer.getFeatures();
                let data = {
                    features: _(response.features).concat(features).uniqBy('properties.Id').value(),
                    type: 'FeatureCollection'
                };

                this._filterFeatures(layer, data);
                this.layer.setFeatures(data, true);
            });
        };
    }

    _debouncedLoadProtectArea(layerName, storeType, isDealership) {
        return _.debounce(this.loadProtectArea(layerName, storeType, isDealership), 600);
    }

    _filterFeatures(layer, data) {
        const filterMetadata = layer.options.filterMetadata;
        const filter = layer.options.filter;
        let filterData = undefined;

        if (filter && filter.properties && Object.keys(filter.properties).length > 0) {
            filterData = Object.keys(filter.properties).map(key => {
                let value = filter.properties[key].data;

                if (!value) {
                    value = Array.isArray(filter.properties[key]) ? filter.properties[key] : [filter.properties[key]];
                }

                return ({ key, value });
            });
        }

        let storeFeatures = layer.getFeatures();

        if (filterData) {
            storeFeatures = storeFeatures.filter(x =>
                filterData.every(y => {
                    const prop = x.properties[y.key];
                    const total = filterMetadata[y.key].total;
                    const values = Array.isArray(y.value) ? y.value : [y.value];

                    if (values && values.length === 0) {
                        return true;
                    }

                    if (values.length === total) {
                        return true;
                    }

                    if (Array.isArray(prop)) {
                        return values.map(z => z.toString())
                            .some(z => prop.some(p => p.toString() === z));
                    }

                    return values.map(z => z.toString()).includes(prop.toString());
                })
            );
        }

        // Este metodo reimplementa o filtro da camada de lojas e cobre apenas filter.properties.
        // filter.shape e irmao de properties, nao esta dentro dele, entao recortes geometricos
        // como o de area pesquisada passavam batido e a protect area de loja fora da area
        // continuava sendo exibida. Delega ao predicado canonico em vez de repetir o turf.
        if (filter && filter.shape) {
            storeFeatures = storeFeatures.filter(store => filterFeature(store, { filter: { shape: filter.shape } }));
        }

        data.features = data.features.filter(x => !this.hide.includes(x.properties.StoreId));
        data.features = data.features.filter(x => storeFeatures.find(y => y.properties.Id === x.properties.StoreId));
    }
}

export default ProtectAreaAfterSalesLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/AfterSales/ProtectAreaAfterSalesLayer.js